// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import previewImageHelper from '../../../../helpers/previewImageHelper';
import maskInput from '../../../../utils/maskInput';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class InfoView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.info-form');

    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'change', selector: '.choose-image' })
  changeImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value !== '') {
      const file = fileElement.files[0];
      const maxSize = 5 * 1024 * 1024; // Maximum file size in bytes (5 MB)

      if (file.size > maxSize) {
        alert(
          maxSize / 1024 / 1024 + 'MB以上のファイルはアップロードできません',
        );
        fileElement.value = '';
      } else {
        $('.image-fields--preview')
          .last()
          .addClass('success');
        previewImageHelper($('.choose-image'), $('.upload-image'));
      }
    }
  }

  @on({ event: 'click', selector: '.choose-image' })
  keepPreviousImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value !== '') {
      this.cloneFileElement[fileElement.id] = fileElement.cloneNode(true);
    }
  }

  @on({ event: 'blur', selector: '.js-reset-invalid-style' })
  resetElementStyles(event: any) {
    const target = $(event.target);
    if (target.hasClass('is-invalid')) {
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }

  render() {
    maskInput();
    this.initDateRangePicker(this.$el);
  }
}
